import { chartScene } from './chart';
import { cityDayScene, cityNightScene } from './city';
import { homeScene } from './home';
import { nightLightsScene } from './nightLights';
import type { Scene, SceneId } from './types';

export const SCENES: Record<SceneId, Scene> = {
  chart: chartScene,
  home: homeScene,
  city_day: cityDayScene,
  city_night: cityNightScene,
  night_lights: nightLightsScene,
};

export function getScene(id: SceneId): Scene {
  return SCENES[id] ?? chartScene;
}
